// Check mark used on the approve action. Decorative — always paired with a visible
// label ("Approve sheet"), so it is aria-hidden. Size via CSS font-size (renders at
// 1em); color via currentColor.
export function CheckIcon({ className }: { className?: string }) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      fill="none"
      stroke="currentColor"
      strokeWidth={2.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...(className ? { className } : {})}
    >
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
}
